module.exports = __webpack_public_path__ + "static/media/payment-icon.4e3eb784.png";